<template>
  <div class="container-box" id="Home">
    <h2 class="title-type-1">
      부킹 현황관리
      <v-tooltip right content-class="tooltip-custom-1">
        <template v-slot:activator="{ on, attrs }">
          <v-icon class="ico-help-1" v-bind="attrs" v-on="on">mdi-help</v-icon>
        </template>
        <span
          >VX의 각 매체별 부킹 스케줄을 확인 합니다. 비어있는 지면을 선택하여
          캠페인을 등록할 수 있으며, 이미 진행중인 캠페인 수정도
          가능합니다.</span
        >
      </v-tooltip>
    </h2>

    <ul class="tab-type-1">
      <li v-for="(media, index) in mediaLists" :key="index">
        <a
          href=""
          :class="{ active: tabID === media.id }"
          @click.prevent="onTabActive(media.id)"
        >
          {{ media.name }}
        </a>
      </li>
    </ul>

    <div class="calendar-info d-flex justify-space-between">
      <div class="calendar-month d-flex align-center">
        <div class="month d-flex align-center">
          <a href="" @click.prevent="onCalendarArrow(-1)">
            <v-icon class="arrow">mdi-chevron-left</v-icon>
          </a>
          <span>
            <v-icon>mdi-calendar-blank</v-icon>
            {{ year }}년 {{ month }}월
          </span>
          <a href="" @click.prevent="onCalendarArrow(1)">
            <v-icon class="arrow">mdi-chevron-right</v-icon>
          </a>
        </div>
        <v-btn
          large
          depressed
          max-height="32px"
          color="#fecd06"
          class="button-type-1 ml-4"
          @click="getBookingLists"
        >
          새로고침
        </v-btn>
      </div>
      <div class="cell-info d-flex align-center">
        <p class="agency">광고주/대행사(확정)</p>
        <p class="inside ml-4">내부 광고(조정)</p>
      </div>
    </div>

    <v-slide-y-transition>
      <div v-if="bookingLists.length > 0">
        <div class="calendar-wrap mt-2">
          <vue-scroll>
            <table class="calendar-tb">
              <caption>
                부킹 현황 표
              </caption>
              <thead>
                <tr>
                  <th scope="col" class="none"></th>
                  <th scope="col" class="none"></th>
                  <th
                    scope="col"
                    v-for="(c, i) in calendar"
                    :key="i"
                    class="cal-cell"
                  >
                    <span class="day">{{ c.dd }}</span>
                    {{ c.ddd }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(booking, index) in bookingLists" :key="index">
                  <th scope="row">{{ booking.name }}</th>
                  <td :colspan="calendar.length + 1" class="pa-0">
                    <table>
                      <tr v-for="cnt in booking.overlap_cnt" :key="cnt">
                        <th>
                          {{
                            booking.campaigns[cnt - 1] &&
                            booking.campaigns[cnt - 1].name
                              ? booking.campaigns[cnt - 1].name
                              : ''
                          }}
                        </th>
                        <td v-for="(bk, j) in calendar.length" :key="j">
                          <a
                            href=""
                            v-if="booking.campaigns[cnt - 1]"
                            :class="[
                              campaignId === booking.campaigns[cnt - 1].id &&
                              j === campaignCellIdx &&
                              booking.id === mediaId
                                ? 'active'
                                : '',
                              cellCampaign(
                                booking.campaigns[cnt - 1].start_at,
                                booking.campaigns[cnt - 1].end_at,
                                j,
                                booking.campaigns[cnt - 1].agency,
                              ),
                            ]"
                            @click.prevent="
                              cellCampaign(
                                booking.campaigns[cnt - 1].start_at,
                                booking.campaigns[cnt - 1].end_at,
                                j,
                                booking.campaigns[cnt - 1].agency,
                              ) === 'none'
                                ? onPopupCampaignWrite(
                                    booking.name,
                                    booking.campaigns[cnt - 1].name,
                                    calendar[j].dd,
                                    booking.id,
                                    booking.campaigns[cnt - 1].id,
                                    j,
                                  )
                                : onPopupCampaignIng(
                                    booking.campaigns[cnt - 1],
                                    booking.id,
                                    j,
                                  )
                            "
                          ></a>
                          <a
                            href=""
                            v-else
                            class="none"
                            @click.prevent="
                              onPopupCampaignWrite(
                                booking.name,
                                '',
                                calendar[j].dd,
                                booking.id,
                                '',
                                j,
                              )
                            "
                          ></a>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </vue-scroll>
        </div>
      </div>
    </v-slide-y-transition>

    <!-- popup_진행중인캠페인 -->
    <v-dialog
      v-model="popCampaignIng.state"
      persistent
      width="320"
      content-class="popup-wrap-1"
    >
      <div class="pa-8">
        <p class="title-type-5">진행중인 캠페인</p>
        <ul class="pop-list">
          <li>
            <p class="property">캠페인 명</p>
            <p class="value">{{ popCampaignIng.name }}</p>
          </li>
          <li>
            <p class="property">기간</p>
            <p class="value">{{ popCampaignIng.period }}</p>
          </li>
          <li>
            <p class="property">광고주</p>
            <p class="value">{{ popCampaignIng.advertiser }}</p>
          </li>
          <li v-if="popCampaignIng.agency">
            <p class="property">대행사</p>
            <p class="value">{{ popCampaignIng.agency }}</p>
          </li>
        </ul>
        <div class="mt-6 text-center">
          <v-btn
            large
            depressed
            max-height="40px"
            color="#fff"
            class="button-type-1"
            @click.prevent="cancelPopup(popCampaignIng.state)"
          >
            취소
          </v-btn>
          <v-btn
            large
            depressed
            max-height="40px"
            color="#fecd06"
            class="button-type-1 ml-2"
            @click="onCampaignModify"
          >
            <v-icon left> mdi-pencil-outline </v-icon>
            캠페인 수정
          </v-btn>
        </div>
      </div>
    </v-dialog>
    <!-- //popup_진행중인캠페인 -->

    <!-- popup_등록캠페인 -->
    <v-dialog
      v-model="popCampaignWrite.state"
      persistent
      width="320"
      content-class="popup-wrap-1"
    >
      <div class="pa-8">
        <p class="title-type-5">캠페인 등록 퀵메뉴</p>
        <ul class="pop-list">
          <li>
            <p class="property">선택 지면</p>
            <p class="value">
              {{ popCampaignWrite.name }} &gt;
              {{ popCampaignWrite.campaignName }}
            </p>
          </li>
          <li>
            <p class="property">선택 기간</p>
            <p class="value">
              {{ year }}. {{ month }}.
              {{ popCampaignWrite.day }}
            </p>
          </li>
        </ul>
        <div class="mt-6 text-center">
          <v-btn
            large
            depressed
            max-height="40px"
            color="#fff"
            class="button-type-1"
            @click.prevent="cancelPopup(popCampaignWrite.state)"
          >
            취소
          </v-btn>
          <v-btn
            large
            depressed
            max-height="40px"
            color="#fecd06"
            class="button-type-1 ml-2"
            @click="onCampaignMove"
          >
            <v-icon left> mdi-plus </v-icon>
            캠페인 등록
          </v-btn>
        </div>
      </div>
    </v-dialog>
    <!-- //popup_등록캠페인 -->

    <SystemAlert v-model="showSystemAlert">
      <div slot="noti-text">{{ logResult }}</div>
      <div slot="noti-btns">
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fecd06"
          class="button-type-1"
          @click.stop="showSystemAlert = false"
        >
          확인
        </v-btn>
      </div>
    </SystemAlert>
  </div>
</template>

<script>
import moment from 'moment';
import tz from 'moment-timezone';
import bus from '@/utils/bus.js';
import SystemAlert from '~@/modal/SystemAlert.vue';
import { listMedia } from '@/api/media';
import { bookingMediaList } from '@/api/booking';
import '../../assets/scss/booking.scss';

export default {
  components: {
    SystemAlert,
  },
  data: () => ({
    mediaLists: [],
    tabID: '',
    yearMonth: '',
    year: '',
    month: '',

    calendar: [],

    bookingLists: [],

    popCampaignWrite: {
      state: false,
      name: '',
      campaignName: '',
      day: '',
    },

    popCampaignIng: {
      state: false,
      name: '',
      period: '',
      advertiser: '',
      agency: '',
    },

    mediaId: '',
    campaignId: '',
    campaignCellIdx: null,

    showSystemAlert: false,
    logResult: '',
  }),
  methods: {
    getDateSetting() {
      moment.updateLocale('ko', {
        weekdays: [
          '일요일',
          '월요일',
          '화요일',
          '수요일',
          '목요일',
          '금요일',
          '토요일',
        ],
        weekdaysShort: ['일', '월', '화', '수', '목', '금', '토'],
      });
      const startOfMonth = moment(this.$route.params.day)
        .startOf('month')
        .format('YYYY-MM-DD ddd');
      const endOfMonth = moment(this.$route.params.day)
        .endOf('month')
        .format('YYYY-MM-DD ddd');
      const year = moment(this.$route.params.day)
        .startOf('month')
        .format('YYYY');
      const month = moment(this.$route.params.day)
        .startOf('month')
        .format('MM');
      const yearMonth = moment().startOf('month').format('YYYYMM');
      const endDayNum = moment(this.$route.params.day)
        .endOf('month')
        .format('DD');

      this.tabID = this.$route.params.id || null;
      this.yearMonth = this.$route.params.day || yearMonth;

      this.year = year;
      this.month = month;

      const calendarLists = [];

      const paramYearMonth = this.$route.params.day
        ? moment(this.$route.params.day, 'YYYYMM')
        : moment().startOf('month');
      for (let i = 0; i < endDayNum; i++) {
        calendarLists.push({
          mmdd: moment(paramYearMonth).add(i, 'days').format('MMDD'),
          dd: moment(paramYearMonth).add(i, 'days').format('DD'),
          ddd: moment(paramYearMonth).add(i, 'days').format('ddd'),
          yymmdd: moment(paramYearMonth)
            .add(i, 'days')
            .tz('Asia/Seoul')
            .format('YYMMDD'),
        });
      }

      this.calendar = calendarLists;
    },
    async getListMedia() {
      try {
        const { data } = await listMedia();
        const getListMedia = data.list;

        //console.log(getListMedia);

        const mediaListCheck = getListMedia.reduce((previous, current) => {
          if (current.is_valid === 'Y') previous.push(current);
          return previous;
        }, []);

        this.mediaLists = mediaListCheck;

        this.tabID = getListMedia[0].id;

        this.getBookingLists();
        bus.$emit('end:spinner');
      } catch (error) {
        bus.$emit('end:spinner');
        console.log(error.response);
      }
    },
    async getBookingLists() {
      try {
        bus.$emit('start:spinner');

        const { data } = await bookingMediaList(this.tabID, this.yearMonth);

        if (data.list.length > 0) {
          //console.log(data.list);
          this.bookingLists = data.list;
        } else {
          this.showSystemAlert = true;
          this.logResult = '조회된 목록이 없습니다.';
        }
        bus.$emit('end:spinner');
      } catch (error) {
        bus.$emit('end:spinner');
        console.log(error.response);
      }
    },
    onTabActive(id) {
      this.$router.push({
        name: 'bookingMedia',
        params: {
          id: id,
          day: this.yearMonth,
        },
      });
    },
    onCalendarArrow(move) {
      this.$router.push({
        name: 'bookingMedia',
        params: {
          id: this.tabID,
          day: moment(this.yearMonth).add(move, 'months').format('YYYYMM'),
        },
      });
    },
    cellCampaign(start_at, end_at, i, agency) {
      const dayS = parseInt(moment(start_at).tz('Asia/Seoul').format('YYMMDD'));
      const dayE = parseInt(moment(end_at).tz('Asia/Seoul').format('YYMMDD'));
      const calendar = parseInt(this.calendar[i].yymmdd);
      return dayS <= calendar && dayE >= calendar
        ? agency
          ? 'agency'
          : 'inside'
        : 'none';
    },
    onPopupCampaignWrite(name, campaignName, day, mediaId, id, j) {
      this.popCampaignWrite = {
        state: true,
        name,
        campaignName,
        day,
      };
      this.mediaId = mediaId;
      this.campaignId = id;
      this.campaignCellIdx = j;
    },
    onPopupCampaignIng(campaign, mediaId, j) {
      //console.log(campaign);
      this.popCampaignIng = {
        state: true,
        name: campaign.name,
        period: `${moment(campaign.start_at).format('YYYY.MM.DD')} ~ ${moment(
          campaign.end_at,
        ).format('YYYY.MM.DD')}`,
        advertiser: campaign.advertiser.name,
        agency: campaign.agency ? campaign.agency.name : '',
      };
      this.mediaId = mediaId;
      this.campaignId = campaign.id;
      this.campaignCellIdx = j;
    },
    onCampaignMove() {
      this.$router.push(`/campaign/register`);
    },
    onCampaignModify() {
      this.$router.push(`/campaign/${this.campaignId}/modify`);
    },
    cancelPopup() {
      this.popCampaignWrite.state = false;
      this.popCampaignIng.state = false;
    },
  },
  created() {
    bus.$emit('start:spinner');
    this.getDateSetting();
    this.getListMedia();
  },
};
</script>
